import * as THREE from 'three'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'


import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';

import { MeshBVH, acceleratedRaycast } from 'three-mesh-bvh';

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger);

import { App } from './js/app.js'
import { Languages } from './js/languages.js'



const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const addThreeJS = () => {


    /* 
    * GET THE HASH NAME
    */
    
    
    const customLabel = document.querySelector('label #name');
    const lastName = document.querySelector('#idName');
    
    const hashText = window.location.hash.substr(1);

    // replace hash _ with space
    const hashTextSpace = hashText.replace(/_/g, ' ');

    const userPreferredLanguage = localStorage.getItem('language') || 'fr';
    const frenchOrEnglish = userPreferredLanguage === 'fr' ? 'toi' : 'you';

    const hashName = hashTextSpace ? hashTextSpace : frenchOrEnglish;
    const hashStringCount = hashName.length;
    customLabel.innerHTML = hashName;

    lastName.innerHTML = hashName;
    
    
    
    
    /**
     * Base
     */
    // Debug
    // const gui = new GUI()
    
    // Canvas
    const canvas = document.querySelector('canvas.webgl');
    
    
    // Scene
    const scene = new THREE.Scene()
    scene.background = new THREE.Color(0x000000)
    
    /*
    * LOADER PROGRESSS
    */
    
    const loading = document.querySelector('.loading');
    
    const progressBar = document.getElementById('progress-bar');
    const progressBarContainer = document.querySelector('.progress-bar-container');
    
    const loadingStartTime = Date.now();
    const loadingManager = new THREE.LoadingManager(
        () => {
            // Loaded
            console.log('loaded');
            window.scrollTo(0, 0);
    
            const loadingDuration = Date.now() - loadingStartTime;
            const remainingTime = Math.max(4000 - loadingDuration, 0);
    
            setTimeout(() => {
                loading.classList.remove('loading-active');
                document.querySelector('section').classList.add('in-view');
            }, remainingTime);
    
            setTimeout(() => {
                progressBarContainer.style.display = 'none';
            }, remainingTime + 1500);
        },
    
        // Progress
        (url, loaded, total) => {
            console.log('progress');
            progressBar.value = (loaded / total) * 100;
        }
    );
    
    
    
    /* 
    * HDRI 
    */
    
    
    scene.background = new THREE.Color(0x000000)
    
    
    // const rgbeLoader1 = new RGBELoader(loadingManager)

    // rgbeLoader1.load('textures/hdri/moonless_golf_2k.hdr', (environmentMap) =>
    //     {
    //         environmentMap.mapping = THREE.EquirectangularReflectionMapping
    
    //         // scene.background = environmentMap
    //         scene.environment = environmentMap   
    //         // scene.environmentIntensity = 0.1;
    //        // scene.backgroundBlurriness = 0.5
        
    //     });
    
    
    
    
    /**
     * Textures
     */
    const textureLoader = new THREE.TextureLoader(loadingManager)
    
    const fireMatcapTexture = textureLoader.load('textures/matcaps/fire.png')
    fireMatcapTexture.colorSpace = THREE.SRGBColorSpace;
    
    const blackMatcapTexture = textureLoader.load('textures/matcaps/black-1.png')
    blackMatcapTexture.colorSpace = THREE.SRGBColorSpace;
    
    
    const textMatCapMaterial = new THREE.MeshMatcapMaterial({
        matcap: blackMatcapTexture,
        opacity: 0,
        transparent: true,
        depthWrite: false,
        side: THREE.DoubleSide,
    })
    
    
    const metalMaterial = new THREE.MeshPhysicalMaterial({
        clearcoat: 1,
        clearcoatRoughness: 0.1,
        metalness: 1,
        reflectivity: 1,
        roughness: 0.5,
        color: new THREE.Color(0x000000),
        ior: 1.8,
        thickness: 1.0,
        normalMap: textureLoader.load('./textures/normal.jpg'),
        transparent: false,
        depthWrite: true,
        side: THREE.DoubleSide,
    });
    
    const tableMaterial = new THREE.MeshPhysicalMaterial({
        metalness: 0.8,
        reflectivity: 0.8,
        roughness: 0.5,
        color: new THREE.Color(0x000000),
        thickness: 1.0,
        transparent: false,
        depthWrite: true,
        side: THREE.DoubleSide,
    });
    
    
    /**
     * Fonts
     */
    const fontLoader = new FontLoader()
    
    
    THREE.Mesh.prototype.raycast = acceleratedRaycast;
    
    fontLoader.load(
        '/fonts/helvetiker_regular.typeface.json',
        (font) => {
            const textGeometry = new TextGeometry(
                hashName,
                {
                    font: font,
                    size: 1,
                    depth: 1,
                    height: 0.2,
                }
            );
    
            textGeometry.center();
            textGeometry.computeBoundingBox();
            const bbox = textGeometry.boundingBox;
    
            const textMesh = new THREE.Mesh(textGeometry, textMatCapMaterial);
            scene.add(textMesh);
    
            // Generate BVH for the text geometry
            const bvh = new MeshBVH(textGeometry);
            textGeometry.boundsTree = bvh;
    
            // Generate random points within bounding box
            const randomPoints = [];
            const numPoints = hashStringCount * 400;
    
            for (let i = 0; i < numPoints; i++) {
                const randomPoint = new THREE.Vector3(
                    THREE.MathUtils.randFloat(bbox.min.x, bbox.max.x),
                    THREE.MathUtils.randFloat(bbox.min.y, bbox.max.y),
                    THREE.MathUtils.randFloat(bbox.min.z, bbox.max.z)
                );
    
                // Use BVH raycasting to check if the point is inside the geometry
                const raycaster = new THREE.Raycaster(randomPoint, new THREE.Vector3(1, 1, 2));
                const intersects = raycaster.intersectObject(textMesh);
    
                if (intersects.length % 2 === 1) {
                    randomPoints.push(randomPoint);
                }
            }
    
            // Create objects at random points
            const gltfLoader = new GLTFLoader(loadingManager);
            gltfLoader.load(
                '/models/screw.glb',
                (gltf) => {
                    let modelGeometry;
                    let modelMaterial;
    
                    gltf.scene.traverse((child) => {
                        if (child.isMesh) {

                            child.castShadow = false;
                            child.receiveShadow = true;

                            modelGeometry = child.geometry;
                            modelMaterial = metalMaterial;
                            modelMaterial.transparent = false;
                        }
                    });
    
                    if (!modelGeometry || !modelMaterial) {
                        console.error('No mesh found in the GLTF model');
                        return;
                    }
    
                    const instancedMesh = new THREE.InstancedMesh(modelGeometry, modelMaterial, randomPoints.length);
    
                    const dummy = new THREE.Object3D();
                    const scale = 0.06;
                    randomPoints.forEach((point, index) => {
                        dummy.position.copy(point);
                        dummy.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI);
                        dummy.scale.set(scale, scale, scale);
                        dummy.updateMatrix();
                        instancedMesh.setMatrixAt(index, dummy.matrix);
                    });
    
                    scene.add(instancedMesh);
                },
                undefined,
                (error) => {
                    console.error('An error occurred while loading the GLTF model:', error);
                }
            );
        }
    );
    
    
    /* 
    * ADD TABLE rect
    */
    
    const geometryRect = new THREE.BoxGeometry( hashStringCount, 0.05, 1 ); 
    const rect = new THREE.Mesh( geometryRect, tableMaterial ); 
    rect.position.y = 0.6;
    rect.material.transparent = true;
    rect.material.opacity = 1;
    
    scene.add( rect );
    
    
    /**
     * LIGHT
     */
    
    
    
    const pointLight = new THREE.PointLight(0xffffff, 10)
    pointLight.position.set(2, 3, 1);
    pointLight.intensity = 10;
    pointLight.size = 2;
    pointLight.color = new THREE.Color(0xff6f00);

    pointLight.castShadow = true;
    pointLight.shadow.mapSize.set(512, 512);

    pointLight.shadow.camera.top = 3
    pointLight.shadow.camera.right = 6
    pointLight.shadow.camera.left = - 6
    pointLight.shadow.camera.bottom = - 3
    pointLight.shadow.camera.far = 10
    
    scene.add(pointLight)
    
    document.addEventListener('mousemove', onMouseMove, false);
    
    
    function onMouseMove(event) {
        // Normalize mouse coordinates to [-1, 1]
        const mouseX = (event.clientX / window.innerWidth) * 2 - 1;
        const mouseY = -(event.clientY / window.innerHeight) * 2 + 1;
    
        // Update point light position
        pointLight.position.x = mouseX * 2; // Adjust multiplier as needed
        pointLight.position.y = mouseY * 2; // Adjust multiplier as needed
    }
    
    
    /**
     * Sizes
     */
    const sizes = {
        width: window.innerWidth + 1,
        height: window.innerHeight + 1
    }
    
    window.addEventListener('resize', () =>
    {
        // Update sizes
        sizes.width = window.innerWidth;
        sizes.height = window.innerHeight;
    
        // Update camera
        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()
        // camera fov
    
        // Update renderer
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    })
    
    /**
     * Camera
     */
    
    const cameraTarget = new THREE.Vector3(0, 0, 0); 
    
    function moveCamera(x, y, z) {
    
        const startQuaternion = camera.quaternion.clone();
        const startPosition = camera.position.clone();
    
        camera.position.set(x, y, z);
        camera.lookAt(cameraTarget);
    
        const endQuaternion = camera.quaternion.clone();
        camera.position.copy(startPosition); // Reset position
    
        let progress = { value: 0 };
    
        gsap.to(progress, {
            value: 1,
            duration: 3.2,
            ease: 'power1.inOut',
            onUpdate: () => {
                camera.position.lerpVectors(startPosition, new THREE.Vector3(x, y, z), progress.value);
                camera.quaternion.slerpQuaternions(startQuaternion, endQuaternion, progress.value);
            },
            onComplete: () => {
                camera.lookAt(cameraTarget);
            }
        });
    }
    
    let currentScroll = 0;
    
    const stickyHeight = window.innerHeight;
    const firstSection = document.querySelector('#section1');
    const secondSection = document.querySelector('#section2');
    const thirdSection = document.querySelector('#section3');
    const fourthSection = document.querySelector('#section4');
    const fifthSection = document.querySelector('#section5');
    
    
    
    
    // Base camera
    const camera = new THREE.PerspectiveCamera(16, sizes.width / sizes.height, 0.1, 100)
    camera.position.set(0, 32, 0);
    camera.lookAt(0,0,0);
    
    scene.add(camera)
    
    // Camera movements
    
    
    // Store initial states
    const initialCameraPosition = { x: camera.position.x, y: camera.position.y, z: camera.position.z };
    const initialBackgroundColor = { r: scene.background.r, g: scene.background.g, b: scene.background.b };
    const initialTextMatCapOpacity = textMatCapMaterial.opacity;
    const initialRectMaterialOpacity = rect.material.opacity;

    let lastCameraPosition = { ...initialCameraPosition };

    
    const GSAPDuration = 2;
    
    // 1st section
    ScrollTrigger.create({
        trigger: firstSection,
        start: "top 80%",
        end: "bottom 20%",
        onEnter: () => {
            console.log('1st section enter');
            lastCameraPosition = { x: camera.position.x, y: camera.position.y, z: camera.position.z };
        },
        onLeaveBack: () => {
            moveCamera(lastCameraPosition.x, lastCameraPosition.y, lastCameraPosition.z);
            console.log('1st section leave back');
        }
    });
    
    // 2nd section
    ScrollTrigger.create({
        trigger: secondSection,
        start: "top 80%",
        end: "bottom 20%",
        onEnter: () => {
            console.log('2nd section enter');

            moveCamera(-12, 0, 0);
            lastCameraPosition = { x: camera.position.x, y: camera.position.y, z: camera.position.z };

    
            gsap.to(scene.background, {
                duration: GSAPDuration,
                r: 0.91,
                g: 0.894,
                b: 0.847,
                ease: 'power2.inOut'
            });
        },
        onLeaveBack: () => {
            moveCamera(lastCameraPosition.x, lastCameraPosition.y, lastCameraPosition.z);
            console.log('2nd section leave back');
    
            // Restore initial background color
            gsap.to(scene.background, {
                duration: GSAPDuration,
                r: initialBackgroundColor.r,
                g: initialBackgroundColor.g,
                b: initialBackgroundColor.b,
                ease: 'power2.inOut'
            });
    
            // Restore initial text material opacity
            gsap.to(textMatCapMaterial, {
                duration: GSAPDuration,
                opacity: initialTextMatCapOpacity,
                ease: 'power2.inOut'
            });
        }
    });
    
    // 3rd section
    ScrollTrigger.create({
        trigger: thirdSection,
        start: "top 80%",
        end: "bottom 20%",
        onEnter: () => {
            console.log('3rd section enter');
            moveCamera(0, 0, -12);

            lastCameraPosition = { x: camera.position.x, y: camera.position.y, z: camera.position.z };

            gsap.to(scene.background, {
                duration: GSAPDuration,
                r: 0.91,
                g: 0.894,
                b: 0.847,
                ease: 'power2.inOut'
            });
    
            gsap.to(textMatCapMaterial, {
                duration: GSAPDuration,
                opacity: 0,
                ease: 'power2.inOut'
            });
        },
        onLeaveBack: () => {
            console.log('3rd section leave back');
            moveCamera(lastCameraPosition.x, lastCameraPosition.y, lastCameraPosition.z);
    
            gsap.to(scene.background, {
                duration: GSAPDuration,
                r: initialBackgroundColor.r,
                g: initialBackgroundColor.g,
                b: initialBackgroundColor.b,
                ease: 'power2.inOut'
            });
    
            gsap.to(textMatCapMaterial, {
                duration: GSAPDuration,
                opacity: initialTextMatCapOpacity,
                ease: 'power2.inOut'
            });
        }
    });
    
    // 4th section
    ScrollTrigger.create({
        trigger: fourthSection,
        start: "top 80%",
        end: "bottom 20%",
        onEnter: () => {
            console.log('4th section enter');
            moveCamera(0, 0, 2);
            lastCameraPosition = { x: camera.position.x, y: camera.position.y, z: camera.position.z };

    
            gsap.to(scene.background, {
                duration: GSAPDuration,
                r: 0,
                g: 0,
                b: 0,
                ease: 'power2.inOut'
            });
        },
        onLeaveBack: () => {
            moveCamera(lastCameraPosition.x, lastCameraPosition.y, lastCameraPosition.z);
            gsap.to(rect.material, {
                duration: GSAPDuration,
                opacity: initialRectMaterialOpacity,
                ease: 'power2.inOut'
            });
        }
    });
    
    // 5th section
    ScrollTrigger.create({
        trigger: fifthSection,
        start: "top 80%", // Adjust the start position
        end: "bottom 20%", // Adjust the end position
        onEnter: () => {

            moveCamera(0, 0, 16);
            lastCameraPosition = { x: camera.position.x, y: camera.position.y, z: camera.position.z };

            gsap.to(scene.background, {
                duration: GSAPDuration,
                r: 1,
                g: 1,
                b: 1,
                ease: 'power2.inOut'
            });

            // hide rect
            gsap.to(rect.material, {
                duration: GSAPDuration,
                opacity: 0,
                ease: 'power2.inOut'
            });
        },
        onLeaveBack: () => {
            console.log('5th section leave back');
            moveCamera(lastCameraPosition.x, lastCameraPosition.y, lastCameraPosition.z);
        }
    });
    
    
    /**
     * Renderer
     */
    const renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        powerPreference: "high-performance",
        antialias: false,
        stencil: false,
        depth: false,
        alpha: false,
        preserveDrawingBuffer: true,
    })
    
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = 3;
    renderer.toneMappingExposure = 1.5;
    
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    
    /*
    * POST PROCESSING
    */
    
    
    const mouse = new THREE.Vector2();
    let frame = 0;
    
    
    const width = window.innerWidth * window.devicePixelRatio;
    const height = window.innerHeight * window.devicePixelRatio;
    
    const options = {
        format : THREE.RGBAFormat,
        type : THREE.FloatType,
        minFilter : THREE.LinearFilter,
        magFilter : THREE.LinearFilter,
        stencilBuffer : false,
        depthBuffer : false
    };
    
    
    const composer = new EffectComposer( renderer );
    composer.addPass( new RenderPass( scene, camera ) );
    
    // const renderPass = new RenderPass( scene, camera );
    //composer.addPass( renderPass );
    
    
    // const shaderPass = new ShaderPass();
    // composer.addPass( shaderPass );
    
    renderer.domElement.addEventListener('mousemove', (e) => {
    mouse.x = e.clientX * window.devicePixelRatio;
    mouse.y = e.clientY * window.devicePixelRatio;
    });
    
    renderer.domElement.addEventListener('mouseleave', (e) => {
        mouse.set(0,0);
    
    });
    // Add SMAA only if the pixel ratio is 1
    if(renderer.getPixelRatio() === 1) {
        const smaaPass = new SMAAPass();
        composer.addPass(smaaPass);
    
        console.log('smaa pass added');
    }
    
    
    
    
    /**
     * Animate
     */
    
    
    document.addEventListener('mousemove', (event) => {
        const mouseX = event.clientX / window.innerWidth;
        const mouseY = 1.0 - event.clientY / window.innerHeight; // Invert Y coordinate
       // shaderPass.material.uniforms.uMouse.value.set(mouseX, mouseY);
    
    });
    
    const clock = new THREE.Clock()
    
    const tick = () => {
    
        const elapsedTime = clock.getElapsedTime();
    
        // Update controls
        // controls.update()
    
        // Render
        renderer.render(scene, camera)
    
        // Update passes
        //shaderPass.material.uniforms.uTime.value = elapsedTime * 0.01;
    
    
    
        // Call tick again on the next frame
        window.requestAnimationFrame(tick)
    
    
        composer.render();
    
    }
    
    tick()
    
    }



Languages();


if (!isMobile) {
    App();
    addThreeJS();
}





